import type { Guide } from '../types';
import { builders } from './helpers';

// The Dashboard guide (8 October 2026): a short tour of the dashboard and the console around it, and a written guide
// that is a map of the whole console. Words under guide.dashboard.*. Since 15 October 2026 (owner: "add onboarding on
// the dashboard") the tour opens by itself on a person's first visit, and it introduces the assistant.

const { link, step, section } = builders('dashboard');
const L = {
  inbox: link('inbox', '/inbox'),
  contacts: link('contacts', '/contacts'),
  broadcasts: link('broadcasts', '/broadcasts'),
  bookings: link('bookings', '/bookings'),
  tickets: link('tickets', '/tickets'),
  flows: link('flows', '/flows'),
  knowledge: link('knowledge', '/knowledge'),
  numbers: link('numbers', '/numbers'),
  billing: link('billing', '/billing'),
  topup: link('topup', '/billing/topup'),
  settings: link('settings', '/settings'),
  team: link('team', '/settings/team'),
  appearance: link('appearance', '/settings/appearance'),
  delivery: link('delivery', '/broadcasts/delivery')
};

export const DASHBOARD_GUIDE: Guide = {
  id: 'dashboard',
  version: 1,
  titleKey: 'guide.dashboard.title',
  introKey: 'guide.dashboard.intro',
  routes: ['/'],
  tour: [
    step('welcome', '/'),
    step('menu', '/', 'shell-menu'),
    step('setup', '/', 'dash-setup,dash-stats'),
    step('stats', '/', 'dash-stats', [L.delivery]),
    step('recent', '/', 'dash-recent', [L.inbox]),
    step('quick', '/', 'dash-quick'),
    step('wallet', '/', 'shell-wallet', [L.topup]),
    step('language', '/', 'shell-language', [L.appearance]),
    step('assistant', '/', 'shell-assistant'),
    step('help', '/', 'dashboard-help')
  ],
  sections: [
    section('overview', 2, 1, []),
    section('figures', 3, 1, [L.inbox, L.contacts, L.broadcasts, L.delivery, L.billing]),
    section('setup', 2, 1, [L.numbers, L.appearance]),
    section('alerts', 2, 0, [L.numbers, L.knowledge]),
    section('menu', 6, 0, [L.inbox, L.contacts, L.bookings, L.tickets, L.flows, L.settings]),
    section('roles', 3, 1, [L.team]),
    section('credits', 2, 1, [L.billing, L.topup]),
    section('help', 2, 0, [])
  ]
};
